export const A = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  REFRESH_MODAL: 'REFRESH_MODAL',
};

export const showModal = (modalType, data) => {
  document.documentElement.style.WebkitOverflowScrolling = 'touch';
  document.body.classList.add('modal-open');
  return {
    type: A.SHOW_MODAL,
    modalType,
    data,
  };
};

export const hideModal = () => {
  document.documentElement.style.WebkitOverflowScrolling = 'initial';
  document.body.classList.remove('modal-open');
  return {
    type: A.HIDE_MODAL,
  };
};

export const refreshModal = (modalType, data) => {
  document.documentElement.style.WebkitOverflowScrolling = 'initial';
  document.body.classList.remove('modal-open');
  return {
    type: A.REFRESH_MODAL,
    modalType,
    data,
  };
};
